var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.url,"alt":""}}),_c('div',{style:({ backgroundImage: 'url(' + _vm.url + ')', height: '100px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }